import { Controller } from "@hotwired/stimulus"

/**
 * Makes a table row selectable by clicking anywhere within it.
 * Triggers a click on a designated "action" or "button" target.
 */
export default class extends Controller {
  /**
   * Handles the click event on the row.
   * Prevents interaction if an interactive element (link, button, input) is clicked.
   */
  select(event) {
    if (event.target.closest("button, a, input, label, select, textarea")) return

    const action = this.element.querySelector("[data-selectable-row-target='action'], [data-selectable-row-target='button']")
    if (action && !action.disabled) action.click()
  }
}
